import { Col, Form, Input, InputNumber, Row } from 'antd'
import React from 'react'

export const TemplatePlcEthernet = (props: { deviceMode: number }) => {
  const labelCol = {
    xs: { span: 12 },
    sm: { span: 5 }
  }

  const ipStyle =
    props.deviceMode == 0
      ? undefined
      : {
          display: 'none'
        }

  return (
    <div>
      <Row gutter={24}>
        <Col span={12} style={ipStyle}>
          <Form.Item label='IP地址' name={['ethernet', 'ip']}>
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label='端口号' name={['ethernet', 'port']}>
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>

        {props.deviceMode == 1 && <Col span={12}></Col>}
      </Row>
      {props.deviceMode == 0 && (
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              labelCol={labelCol}
              label='支持设备'
              name='compatibleModels'
            >
              <Input.TextArea disabled={true} />
            </Form.Item>
          </Col>
        </Row>
      )}
    </div>
  )
}
